<template>
  <base-page-layout>
    <div>
      <v-layout align-center class="error-page pa-0" fill-height row wrap>
        <v-flex class="text-block" sm6 xs12>
          <p v-if="errorType" class="error-type" :class="colorType">
            <mf-icon>{{ icon }}</mf-icon>
            {{ errorType }}
          </p>
          <p class="error-title">{{ title }}</p>
          <p class="error-message">{{ firstMessage }}</p>
          <p class="error-message">
            {{ secondMessage }} <span class="message-focus">{{ focusMessage }}</span>
          </p>
          <p v-if="underMessage" class="error-under-message">{{ underMessage }}</p>
          <slot name="buttons"></slot>
        </v-flex>
        <v-flex class="error-image" sm6 xs12>
          <img class="responsive-image" :src="imagePath" />
        </v-flex>
      </v-layout>
    </div>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
export default {
  components: {
    BasePageLayout,
  },
  props: {
    icon: {
      type: String,
      required: false,
    },
    errorType: {
      type: String,
      required: false,
    },
    colorType: {
      type: String,
      required: false,
      validator: (value) => ['success', 'error'].indexOf(value) !== -1,
    },
    title: {
      type: String,
      required: false,
    },
    firstMessage: {
      type: String,
      required: false,
    },
    secondMessage: {
      type: String,
      required: false,
    },
    focusMessage: {
      type: String,
      required: false,
    },
    underMessage: {
      type: String,
      required: false,
    },
    imageName: {
      type: String,
      required: true,
    },
  },
  computed: {
    imagePath() {
      return require(`@/assets/${this.imageName}`)
    },
  },
}
</script>

<style lang="scss">
.error-page {
  height: 85vh;
  @media screen and (min-width: 600px) {
    img {
      max-width: 30vw;
    }
  }
  button {
    margin-top: 15px;
    border-radius: 5px;
    margin-left: 0;
  }
  .text-block {
    padding-left: 10%;
    padding-right: 5%;
  }
  .error-type {
    font-size: 18px;
    margin: 0;
    &.success {
      background-color: $cinza-l90 !important;
      color: $verde-0;
      i {
        color: $verde-0;
      }
    }
    &.error {
      background-color: $cinza-l90 !important;
      color: $vermelho-0;
      i {
        color: $vermelho-0;
      }
    }
  }
  .error-title {
    font-size: 36px;
    color: $preto;
    opacity: 0.8;
    font-weight: bold;
  }
  .error-message {
    font-size: 16px;
    color: $cinza-0;
    margin-bottom: 3px;
  }
  .message-focus {
    color: $cinza-d20;
  }
  .error-under-message {
    font-size: 24px;
    color: $marca-0-l40;
  }

  .error-image {
    text-align: center;
  }
}
</style>
